import React from "react";
import RightHighlightedArrow from "../../../assets/images/icons/rgt_arrow_vector_bl.png";
import "./index.css";

const GenericGridDisplay = ({
  headerText,
  btnText,
  onBtnClick,
  imagesTab,
  mainImg,
  logos,
  tabIndex,
  onImgClick,
  mobileScreenClass = "",
}) => {
  return (
    <div className={`metal-cloud-container`}>
      <div className="display-section">
        {imagesTab
          .slice(0, imagesTab?.length / 2)
          .map(({ text, icon, id = "" }, idx) => {
            return (
              <div
                style={{ cursor: onImgClick && "pointer" }}
                onClick={() => {
                  onImgClick && onImgClick(id);
                }}
                key={idx}
                className="displayBoxes"
              >
                <img src={icon} alt="" loading="lazy" />
                <p>{text}</p>
              </div>
            );
          })}
      </div>
      <div
        className="mid-section"
        /* The 400px was sized for the old flattened finance image; the real
           logo grid sets its own height and would otherwise overflow into the
           cards below. */
        style={{ height: logos || tabIndex != 6 ? "auto" : "400px" }}
      >
        <div className="mid-header">{headerText}</div>
        {btnText && (
          <div onClick={onBtnClick} className="section-btn">
            <button>{btnText}</button>
            <img src={RightHighlightedArrow} alt="" loading="lazy" />
          </div>
        )}
        {/* The finance panel draws its partner logos as real elements rather
            than one flattened image, so a logo can be swapped without
            re-exporting the whole composite. */}
        {logos ? (
          <ul className="financeLogoGrid">
            {logos.map((logo) => (
              <li key={logo.name} className="financeLogoCircle">
                <img
                  src={logo.src}
                  alt={logo.name}
                  loading="lazy"
                  style={{ width: logo.box.width, height: logo.box.height }}
                />
              </li>
            ))}
          </ul>
        ) : (
          <div className="image-section">
            <img
              src={mainImg}
              style={{ height: `${tabIndex == 6 ? "350px" : "auto"}` }}
              alt=""
              loading="lazy"
            />
          </div>
        )}
      </div>

      <div className="display-section">
        {imagesTab
          .slice(imagesTab?.length / 2)
          .map(({ text, icon, id = "" }, idx) => {
            return (
              <div
                key={idx}
                onClick={() => {
                  onImgClick && onImgClick(id);
                }}
                style={{ cursor: onImgClick && "pointer" }}
                className="displayBoxes"
              >
                <img src={icon} alt="" loading="lazy" />
                <p>{text}</p>
              </div>
            );
          })}
      </div>
      <div
        className={`mobileDisplaySection ${mobileScreenClass} ${
          logos ? "financeMobileCards" : ""
        }`}
      >
        {imagesTab.map(({ text, icon, alignment = "column", id = "" }, idx) => {
          return (
            <div
              onClick={() => {
                onImgClick && onImgClick(id);
              }}
              key={idx}
              style={{
                flexDirection: alignment,
                cursor: onImgClick && "pointer",
              }}
              className="displayBoxes"
            >
              <img src={icon} alt="" loading="lazy" />
              <p>{text}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GenericGridDisplay;
